import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';

// import HouseIcon from '../../assets/svg/HouseIcon';

import MenuItemBottomButton from '../../common/menuitem/MenuItemBottomButton';
import DeliveryCard from './DeliveryCard';
import { ModalCloseButton } from '../../common/ModalCloseButton';
import { closeCart, closeCartDelivery } from '../../../actions/modals';
import { cartInfoUpdate, loadCartInformation, getDeliveryCharge } from '../../../actions/cart';
import { getFormattedPickupTime } from '../../../utils/dateUtil';

class DeliveryAddressModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            error: '',
            loading: false,        
        }
    }

  



    // Address card function
    renderAddressCard(item) {
        return (
            <a 
                onClick={() => { this.props.setDeliveryAddress(item.address, item.instructions, item.lat, item.lng) }} 
            >
                
                <DeliveryCard deliveryAddress={item.address} deliveryInstructions={item.instructions} />
            </a>
        );
    }

    render() {
        return (
            <Modal
                isOpen={this.props.open}
                contentLabel="Select Delivery Address"
                overlayClassName="modal-overlay"
                className="modal-window"
            >
                <div>
                    <ModalCloseButton 
                        clickAction={() => { this.props.dispatch(closeCartDelivery()) }} 
                    />

                    {(this.props.deliveryAddressShowChoose) ? (

                        <div className="delivery-address-modal-card-padding">
                            <p className="menu-item-name">Select a Delivery Address</p>
                            <div>
                                <div className="account-button in-receipt usual-orders"
                                 onClick={() => {
                                    this.props.setDeliveryAddressWindow(false);
                                }}
                                >
                                        Use Different Address
                                </div>
                                <div>
                                    {this.props.loggedUser.addresses.map((address) => this.renderAddressCard(address))}
                                </div>
                            </div>
                        </div>
                    ): (
                        <div className="delivery-modal-info-wrapper">
                            <h2 className="heading in-item">Add New Delivery Address</h2>
                            <div className="new-delivery-address-window">
                                <h3 className="name-title delivery-address-label-font">Delivery Address:</h3>

                                <div className="new-delivery-address-form cart-modal-autocomplete">
                                    <GooglePlacesAutocomplete
                                        selectProps={{
                                            value: this.props.cart.address,
                                             onChange: (e) => {
                                             this.props.dispatch(cartInfoUpdate({ prop: 'delivery_address', value: e.value.description }));
                                            }
                                        }}
                                    />
                                </div>

                                <h3 className="name-title delivery-address-label-font">Special Instructions:</h3>
                                <div className="new-delivery-address-form">
                                    <input 
                                        className="text-field-input special-instruction-field-cart-modal"
                                        placeholder="Special instructions for our drivers..."
                                        value={this.props.cart.instructions}
                                        blockLabel={true}
                                        onChange={(value) => this.props.dispatch(cartInfoUpdate({ prop: 'delivery_instructions', value: value.target.value }))}
                                    />
                                </div>

                                <div className="new-address-order-information-buttons">
                                    <a
                                        className="account-button in-receipt usual-orders modal-button-width"
                                        onClick={() => { 
                                            this.props.setDeliveryAddressWindow(false);
                                            this.props.dispatch(closeCartDelivery());
                                        }}  
                                    >
                                        Use This Address
                                    </a>
                                    <a
                                        className="account-button in-receipt usual-orders modal-button-width cancel-button"
                                        onClick={() => {
                                            this.props.setDeliveryAddressWindow(false);
                                            this.props.dispatch(closeCartDelivery());
                                        }}
                                    >
                                        Cancel
                                    </a>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {

    return {
      logged_in: state.auth.logged_in,
      loggedUser: state.auth.user,
      cart: state.cart,
      currentLocation: state.currentLocation.info,
      open: state.modals.cartDelivery
    };
  };

export default connect(mapStateToProps)(DeliveryAddressModal);
